import DropdownRowBase from './DropdownRowBase'
import {AccountSettingsIcon} from '../../../assets/UserMenuIcons'
import {accountSettingsPath} from '../../../../lib/urlTools'

const AccountSettingsRow = () => (
  <DropdownRowBase path={accountSettingsPath}>
    <a>
      <AccountSettingsIcon aria-hidden='true' className='dropdown-icon' focusable='false' />
      Settings
    </a>
  </DropdownRowBase>
)

export default AccountSettingsRow
